module.exports = __webpack_public_path__ + "static/media/07_blanco.7488b934.svg";